import auth from '../api/auth';

import {
  WHO_AMI,
  WHO_AMI_DELETE,
  LOGIN_FAILURE
} from './types';

const initialState = {
  pk: null,
  username: null,
  email: null,
  first_name: null,
  last_name: null,
};

const getters = {
  getPk: state => state.pk,
};

const actions = {
  getwho({ commit }) {
    return auth.getAccountDetails()
      .then(({ data }) => commit(WHO_AMI, data))
      .catch(() => commit(LOGIN_FAILURE));
  },
  whoami_purge({ commit }) {
    commit(WHO_AMI_DELETE);
  }
};

const mutations = {
  [WHO_AMI](state, data) {
    state.pk = data.pk;
    state.username = data.username;
    state.email = data.email;
    state.first_name = data.first_name;
    state.last_name = data.last_name;
  },
  [WHO_AMI_DELETE](state) {
    state.pk = null;
    state.username = null;
    state.email = null;
    state.first_name = null;
    state.last_name = null;
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};


